import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AssignmentCorrectState {
  is_correct: boolean;
}

const initialState: AssignmentCorrectState = {
  is_correct: false,
};

const assignmentCorrectSlice = createSlice({
  name: "assignmentCorrect",
  initialState,
  reducers: {
    setAssignmentCorrect: (
      state,
      action: PayloadAction<AssignmentCorrectState>
    ) => {
      state.is_correct = action.payload.is_correct;
    },
  },
});

export const { setAssignmentCorrect } = assignmentCorrectSlice.actions;
export default assignmentCorrectSlice.reducer;
